module.exports = __webpack_public_path__ + "static/wenhao.d97aa741.png";